import * as API from './index'

export default {
    get: params => {
        return API.GET('/api/PlayerMatchRule/Get', params)
    },
    getList: params => {
        return API.GET('/api/PlayerMatchRule/List', params)
    },
    select: params => {
        return API.GET('/api/PlayerMatchRule/select', params)
    },
    add: params => {
        return API.POST('/api/PlayerMatchRule/Add', params)
    },
    edit: params => {
        return API.POST('/api/PlayerMatchRule/Edit', params)
    },
    delete: params => {
        return API.DELETE('/api/PlayerMatchRule/delete', params)
    },
    deleteBatch: params => {
        return API.DELETEBATCH('/api/PlayerMatchRule/DeleteBatch', params)
    },
    compose:params=>{
        return API.GET('/api/PlayerMatchRule/Compose', params)
    }
}


// WEBPACK FOOTER //
// ./src/apis/matchrule.js